export default __webpack_public_path__ + "static/media/user_management.3b67ec77.svg";